import { AutomationTask } from "../contentScript/types";

/**
 * Records automation tasks as they are called through the TabProxy
 */
export class TaskRecorder {
  private tasks: AutomationTask[] = [];

  /**
   * Add a task to the recording
   */
  add(task: AutomationTask): void {
    this.tasks.push(task);
  }

  /**
   * Get all recorded tasks (returns a copy)
   */
  getTasks(): AutomationTask[] {
    return [...this.tasks];
  }

  /**
   * Clear all recorded tasks
   */
  clear(): void {
    this.tasks = [];
  }

  /**
   * Get the number of recorded tasks
   */
  get length(): number {
    return this.tasks.length;
  }
}
